import React from 'react';
import SignOutButton from './SignOutButton';
import LKButton from './LKButton';

const TeacherUserButtons = ({ signOut, history }) => (
  <div className="header-user__btns">
    <LKButton history={history} />
    <SignOutButton signOut={signOut} />
  </div>
);

export default TeacherUserButtons;
